import React, { useState } from 'react';
import Header from '../../components/ui/Header';
import QuickActionToolbar from '../../components/ui/QuickActionToolbar';
import Icon from '../../components/AppIcon';

import TaxSummaryCards from './components/TaxSummaryCards';
import TaxCalendar from './components/TaxCalendar';
import TaxJurisdictions from './components/TaxJurisdictions';
import TaxForms from './components/TaxForms';
import TaxReconciliation from './components/TaxReconciliation';

const TaxManagement = () => {
  const [activeView, setActiveView] = useState('overview');

  const quickActions = [
    {
      label: 'Generate Tax Form',
      onClick: () => console.log('Generate tax form'),
      variant: 'default',
      icon: 'FileText'
    },
    {
      label: 'File Return',
      onClick: () => console.log('File return'),
      variant: 'default',
      icon: 'Send'
    },
    {
      label: 'Make Payment',
      onClick: () => console.log('Make payment'),
      variant: 'outline',
      icon: 'CreditCard'
    },
    {
      label: 'Export Report',
      onClick: () => console.log('Export report'),
      variant: 'outline',
      icon: 'Download'
    }
  ];

  const views = [
    { id: 'overview', label: 'Overview', icon: 'LayoutDashboard' },
    { id: 'calendar', label: 'Tax Calendar', icon: 'Calendar' },
    { id: 'jurisdictions', label: 'Jurisdictions', icon: 'MapPin' },
    { id: 'forms', label: 'Forms & Filing', icon: 'FileText' },
    { id: 'reconciliation', label: 'Reconciliation', icon: 'CheckCircle' }
  ];

  const renderView = () => {
    switch (activeView) {
      case 'overview':
        return (
          <div className="space-y-6">
            <TaxSummaryCards />
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <TaxCalendar compact />
              <TaxReconciliation compact />
            </div>
          </div>
        );
      case 'calendar':
        return <TaxCalendar />;
      case 'jurisdictions':
        return <TaxJurisdictions />;
      case 'forms':
        return <TaxForms />;
      case 'reconciliation':
        return <TaxReconciliation />;
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <QuickActionToolbar actions={quickActions} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Page Header */}
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-900">Tax Management</h1>
          <p className="mt-2 text-sm text-gray-600">
            Manage tax calculations, compliance, and filing across all jurisdictions
          </p>
        </div>

        {/* View Navigation */}
        <div className="mb-6 bg-white rounded-lg shadow-sm border border-gray-200 p-2">
          <div className="flex flex-wrap gap-2">
            {views?.map((view) => (
              <button
                key={view?.id}
                onClick={() => setActiveView(view?.id)}
                className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                  activeView === view?.id
                    ? 'bg-primary text-white' :'text-gray-700 hover:bg-gray-100'
                }`}
              >
                <Icon name={view?.icon} size={16} />
                {view?.label}
              </button>
            ))}
          </div>
        </div>

        {/* View Content */}
        {renderView()}
      </div>
    </div>
  );
};

export default TaxManagement;